import { render, staticRenderFns } from "./OfficialPostItemContentsParts.vue?vue&type=template&id=414e4ccf&scoped=true"
import script from "./OfficialPostItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./OfficialPostItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./OfficialPostItemContentsParts.vue?vue&type=style&index=0&id=414e4ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414e4ccf",
  null
  
)

export default component.exports